import { render, staticRenderFns } from "./ProductBox_v2.vue?vue&type=template&id=37a3a144&scoped=true"
import script from "./ProductBox_v2.vue?vue&type=script&lang=js"
export * from "./ProductBox_v2.vue?vue&type=script&lang=js"
import style0 from "./ProductBox_v2.vue?vue&type=style&index=0&id=37a3a144&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3a144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a3a144')) {
      api.createRecord('37a3a144', component.options)
    } else {
      api.reload('37a3a144', component.options)
    }
    module.hot.accept("./ProductBox_v2.vue?vue&type=template&id=37a3a144&scoped=true", function () {
      api.rerender('37a3a144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/ProductBox_v2.vue"
export default component.exports